'use strict';

import * as Onyx from '../lib/onyx.min.js';

const SCALE = 0.5;
const ROTATE_SPEED = 0.1;

export default class Star extends Onyx.Entity {
    constructor(position = [0,0], scale = 1, rotation = 0){
        super();

        this.transform.translateTo(position[0], position[1], 0);
        this.transform.scaleTo(SCALE, SCALE, SCALE);
           
        Onyx.ImportModelFromOBJ.load({src: "res/models/star.obj"}).then((model) => {
            this.addComponent(model);

            this.components[0].meshes[0].material.ambientTexture = this.parentScene.caustic;
            this.components[0].meshes[0].material.buildProgram();
        });
    }

    onSpawn(...args){
        super.onSpawn(...args);

        let t = new Onyx.Tween();
        t.easeIn(this.transform, "y", this.transform.y + 150, 1000, () => {
            // this.parentScene.remove(this);

            this.parentScene.setModulate((scene, dt, progress) => {
                var v = 0 + (Math.PI-0)*((-Math.cos(progress*Math.PI)/2) + 0);
                this.components[0].transform.translateY(-v / 2);
            }, 1000);
        });
        this.parentScene.addComponent(t);


    }

    update(...args){
        this.transform.rotateY(0.1);
    }
}